<app-toolbar-section [label]="'app.__TEMPERATURE' | AsyncLang | async">
  <app-toolbar-select-item [label]="'app.__MAP_FILTER_FILTERED' | AsyncLang | async"
    [selected]="temperatureQuality() === TemperatureQuality.HIGH"
    (select)="selectTemperatureQuality(TemperatureQuality.HIGH)"/>
  <app-toolbar-select-item [label]="'app.__MAP_FILTER_NOT_FILTERED' | AsyncLang | async"
    [selected]="temperatureQuality() === TemperatureQuality.LOW"
    (select)="selectTemperatureQuality(TemperatureQuality.LOW)"/>
</app-toolbar-section>

<app-toolbar-section [label]="'app.__RAIN' | AsyncLang | async">
  <app-toolbar-select-item [label]="'station.__RAIN_NOW' | AsyncLang | async"
    [selected]="rainScale() === RainScale.RAIN_60MIN"
    (select)="selectRainScale(RainScale.RAIN_60MIN)"/>
  <app-toolbar-select-item [label]="'station.__RAIN_TODAY' | AsyncLang | async"
    [selected]="rainScale() === RainScale.RAIN_24H"
    (select)="selectRainScale(RainScale.RAIN_24H)"/>
  <app-toolbar-select-item [label]="'station.__RAIN_LIVE' | AsyncLang | async"
    [selected]="rainScale() === RainScale.RAIN_LIVE"
    (select)="selectRainScale(RainScale.RAIN_LIVE)"/>
</app-toolbar-section>

<app-toolbar-section [label]="'common.__WIND' | AsyncLang | async">
  <app-toolbar-select-item [label]="'app.__TYPE_WIND' | AsyncLang | async"
    [selected]="windType() === WindType.WIND"
    (select)="selectWindType(WindType.WIND)"/>
  <app-toolbar-select-item [label]="'app.__MAP_GUST' | AsyncLang | async"
    [selected]="windType() === WindType.GUST"
    (select)="selectWindType(WindType.GUST)"/>
</app-toolbar-section>